import { redirect } from '@tanstack/react-router'

/**
 * `beforeLoad` for a module's index route: its bare URL opens the "All" tab, keeping the ids and search
 * the URL already holds. `to` is not checked against the route tree here; `routes.defaultTabRedirect.test.ts`
 * asserts every target.
 */
export const redirectToAllTab =
	(to: string) =>
	({ params, search }: { params: object; search: object }): never => {
		throw redirect({ to, params: { ...params, type: 'all' }, search, replace: true } as never)
	}
